import { Route } from '@angular/router';
import { TInitEventHistoryGridScope } from './init-event-history-grid-scope.token';

export const createInitEventHistoryRoute = (data: {
  historyListTitleKey: string;
  historyBackTitleKey: string;
  historyGridScope: TInitEventHistoryGridScope;
}): Route => {
  return {
    path: 'history',
    data,
    loadComponent: () =>
      import('./init-event-history.component').then(
        (c) => c.InitEventHistoryComponent,
      ),
    children: [
      {
        // id записи журнала (eventId в API); initEventId — param `id` маршрута карточки ИС выше по дереву
        path: ':id',
        loadComponent: () =>
          import('@app/shared/event-log/event-log-card/event-log-card.component').then(
            (c) => c.EventLogCardComponent,
          ),
      },
    ],
  };
};
